module.exports = __webpack_public_path__ + "img/banner_afa_lakers_op_horizontal.107fac3d.png";